<kendo-treeview [nodes]="locations" textField="name" childrenField="items" [(expandedKeys)]="expandedKeys"
  expandBy="locationId" [filterable]="false" [filter]="filterTerm" kendoTreeViewExpandable
  kendoTreeViewHierarchyBinding>
  <ng-template kendoTreeViewNodeTemplate let-dataItem>
    <input [(ngModel)]="dataItem.isSelected" (click)="handleCheck(dataItem)" [disabled]="!dataItem.isUser"
      class="cc-filter-checkbox" type="checkbox" kendoCheckBox /><span class="selectoritem"
      (click)="handleCheck(dataItem)"
      [ngClass]="{'disableNode': dataItem.isUser === false,'itemactive' : selectedUserId == dataItem.id && dataItem.isUser === false}">
      {{ dataItem.name }}
    </span>

  </ng-template>
</kendo-treeview>
